/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import { usePreloadedQuery } from 'react-relay';

/**
 * This is the component description.
 */
const PreloadedTestData = ({
  query,
  queryReference
  // ...otherProps
}) => {
  const data = usePreloadedQuery(query, queryReference);
  return /*#__PURE__*/React.createElement("pre", null, JSON.stringify(data, null, 2));
};
PreloadedTestData.propTypes = {
  /**
   * The query to be used to query the test data
   */
  query: PropTypes.objectOf(PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  /**
   *  The query reference to be used to access the preloaded data
   */
  queryReference: PropTypes.objectOf(PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.object]))
};
PreloadedTestData.defaultProps = {
  // someProp:false
};
export default PreloadedTestData;